<template>
  <v-card-subtitle class="caption py-0 px-2">
    <div class="good3-chipsDTA good3-damage">
      <v-icon small>mdi-sword</v-icon><br>
      {{ humanDisplayLargeNumbers(damage) }}
    </div>
    <div class="good3-chipsDTA good3-toughness">
      <v-icon small>mdi-shield-cross</v-icon><br>
      {{ humanDisplayLargeNumbers(toughness) }}
    </div>
    <div class="good3-chipsDTA good3-healing">
      <v-icon small>mdi-hospital</v-icon><br>
      {{ humanDisplayLargeNumbers(healing) }}
    </div>
  </v-card-subtitle>
</template>

<script>
// MIXINS
import { Good3Lib } from '../../good3lib/good3_lib'

// VUEX
import { mapGetters } from 'vuex'

// DEFAULT
export default {
  name: 'GOOD3_PROFILE_HERO_LIST_DTH',

  // Importing VUEJS shared resources
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {
    damage: Number,
    toughness: Number,
    healing: Number
  },
  components: {},
  mixins: [Good3Lib],

  // Accessible properties:
  // • data
  // • computed
  // • watch
  data: () => ({
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
    ])
  },
  watch: {},

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted
  mounted () {
  },

  // Components methods
  methods: {
  }
}
</script>

<style scoped>

</style>
